import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ScientificAnalysis } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { InfinitePaginatorResourceService, InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { Nullable } from '@/shared/types/app.types'
import { ColDef, ColGroupDef } from '@ag-grid-community/core'

export abstract class ScientificAnalysisDatasource<T> implements InfinitePaginatorResourceService<T> {
    protected scientificAnalysis: ScientificAnalysis
    private totalElements: Nullable<number>=0

    constructor(scientificAnalysis: ScientificAnalysis) {
        this.scientificAnalysis = scientificAnalysis
    }

    abstract getLabAndCaseId(selectedRow: T): [Nullable<number>, Nullable<number>]
    abstract getPatAndLabId(selectedRow: T): [Nullable<number>, Nullable<number>]
    abstract paginator(filterModel: CommonFilterModel, params: CommonParams, ...restOfParams: any[]): Promise<InfinitePaginatorResponse<T>>
    abstract getGridColumns(): (ColDef | ColGroupDef)[]

    protected setTotalElements(totalElements: Nullable<number>):void {
        this.totalElements = totalElements
    }

    public getTotalElements(): Nullable<number> {
        return this.totalElements
    }

    public getRowHeight(data: T):number {
        // assuming 45 characters per line, with 18 lines
        const htmlFieldsLength = this.getHTMLFieldsList(data).map(htmlField => htmlField.length)
        const maxLength = htmlFieldsLength.length > 0 ? Math.max.apply(null, htmlFieldsLength) : 0
        if (maxLength) {
            let calc = 45 * (Math.floor(maxLength / 25) + 2)
            if (calc > 200) calc = 220
            return calc
        } else {
            return 30
        }
    }

    abstract getHTMLFieldsList(data:T): string[]
}

export abstract class ScientificAnalysisPatientNameDatasource<T> extends ScientificAnalysisDatasource<T> {
    abstract getPatientColumns(selector?: string): [string, string]
}
